export default __webpack_public_path__ + "static/media/tk1.1db82c79.png";